export default __webpack_public_path__ + "static/media/iHR.19d2e0e9.png";